import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
function ServiceCategoryGroupViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.ServiceCategoryGroup = ko.observable();
    self.ServiceCategoryGroup1 = ko.observable();
    self.ServiceCategoryGroup2 = ko.observable();
    self.ServiceCategoryGroup3 = ko.observable();
    self.ServiceCategoryGroup4 = ko.observable();
    self.ServiceCategoryGroup5 = ko.observable();
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.ServiceCategoryGroup())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.Translate = function () {
        var translateDialog = new TranslateDialogViewModel(self.ServiceCategoryGroup1, self.ServiceCategoryGroup2, self.ServiceCategoryGroup3, self.ServiceCategoryGroup4, self.ServiceCategoryGroup5);
        translateDialog.Open().then(function () { });
    };
    self.ServiceCategoryGroupComputed = ko.computed(function () {
        if (self != undefined) {
            self.ServiceCategoryGroup1();
            self.ServiceCategoryGroup2();
            self.ServiceCategoryGroup3();
            self.ServiceCategoryGroup4();
            self.ServiceCategoryGroup5();
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    self.ServiceCategoryGroup(self.ServiceCategoryGroup1());
                    break;
                case 2:
                    self.ServiceCategoryGroup(self.ServiceCategoryGroup2());
                    break;
                case 3:
                    self.ServiceCategoryGroup(self.ServiceCategoryGroup3());
                    break;
                case 4:
                    self.ServiceCategoryGroup(self.ServiceCategoryGroup4());
                    break;
                case 5:
                    self.ServiceCategoryGroup(self.ServiceCategoryGroup5());
                    break;
            }
        }
    });
    self.ServiceCategoryGroup.subscribe(function () {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.ServiceCategoryGroup1(self.ServiceCategoryGroup());
                break;
            case 2:
                self.ServiceCategoryGroup2(self.ServiceCategoryGroup());
                break;
            case 3:
                self.ServiceCategoryGroup3(self.ServiceCategoryGroup());
                break;
            case 4:
                self.ServiceCategoryGroup4(self.ServiceCategoryGroup());
                break;
            case 5:
                self.ServiceCategoryGroup5(self.ServiceCategoryGroup());
                break;
        }
    });
}
Bao.inherit(ServiceCategoryGroupViewModel, SearchPaging);
ServiceCategoryGroupViewModel.prototype.PrimaryKey = "ServiceCategoryGroupId";
ServiceCategoryGroupViewModel.prototype.RefreshUrl = "ServiceCategoryGroup/Get";
ServiceCategoryGroupViewModel.prototype.SaveUrl = "ServiceCategoryGroup/Save";
ServiceCategoryGroupViewModel.prototype.DeleteUrl = "ServiceCategoryGroup/Delete";
ServiceCategoryGroupViewModel.prototype.IsInUseUrl = "ServiceCategoryGroup/IsInUse";
ServiceCategoryGroupViewModel.prototype.PermissionForward = "ServiceCategoryGroupMoveForwardSearch";
ServiceCategoryGroupViewModel.prototype.PermissionBackward = "ServiceCategoryGroupMoveBackwardSearch";
ServiceCategoryGroupViewModel.prototype.PermissionSave = "ServiceCategoryGroupSave";
ServiceCategoryGroupViewModel.prototype.PermissionRefresh = "ServiceCategoryGroupRefresh";
ServiceCategoryGroupViewModel.prototype.PermissionDelete = "ServiceCategoryGroupDelete";
export default ServiceCategoryGroupViewModel;